import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

function DialogTailwind_V2({ message, resetState, onDismiss }) {

    const [isOpen, setIsOpen] = useState(true)

    const overlayClass = cx('fixed z-30 inset-0 overflow-y-auto', {
        hidden: !isOpen,
    });
    const dialogClass = cx('relative mx-auto mt-20', {
        'grid grid-cols-4 gap-4 w-2/12 md:w-2/3': true,
        'opacity-0': !isOpen,
        'scale-95': !isOpen,
        'opacity-100': isOpen,
        'scale-100': isOpen,
    });

    return (
        <div className={overlayClass}>
            <div className="flex items-center justify-center min-h-screen">
                <div className={dialogClass}>
                    <div className="col-span-4 bg-[#B9DFC5] shadow-my-green rounded-lg shadow-lg overflow-hidden">
                        <div className="px-4 py-[2rem] flex justify-center items-center break-normal text-center">{message}</div>
                        <div className="px-4 py-2 bg-gray-100 text-right">
                            <button
                                type="button"
                                className="text-[#000000] hover:text-gray-700 focus:outline-none"
                                onClick={() => {
                                    onDismiss()
                                    resetState('')
                                    setIsOpen(false)
                                }}
                            >
                                ปิด
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

DialogTailwind_V2.propTypes = {
    message: PropTypes.node.isRequired,
    resetState: PropTypes.func.isRequired,
};
export default DialogTailwind_V2